export default __webpack_public_path__ + "static/media/mask.5c441544.jpg";